<template>
  <router-view />
</template>

<script>
  export default {
    name: "RouteView"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/RouteView.vue